<template>
	<div>
		<ui-modal
			class="has-left-aside"
			:name="name"
			:title="title"
			:icon="icon">
			<div class="aside" slot="left">
				<div class="aside-header">
					<ui-button v-show="currentActive > 0" @click="previous"><i class="fal fa-angle-left"></i> Voltar</ui-button>
				</div>
				<div class="aside-content">
					<div class="menu">
						<div class="menu-item"
							v-for="item in items"
							:class="[{ 'selected': item.isSelected }, { 'checked': item.isChecked }]"
							:key="item.name">
							<i class="fal fa-square"></i> {{ item.name }}
						</div>
					</div>
				</div>
				<div class="aside-footer"></div>
			</div>

			<div>
				<ui-overlay-load v-if="load" />
				<slot />
			</div>

			<div slot="footer">
				<ui-button design="md success mw-100" @click="next" v-show="currentActive !== (totalItems - 1)">Avançar <i class="fal fa-long-arrow-right"></i></ui-button>
				<ui-button design="md success mw-100" @click="next" v-show="currentActive === (totalItems - 1)">Finalizar <i class="fal fa-long-arrow-right"></i></ui-button>
			</div>
		</ui-modal>
	</div>
</template>

<script>
	import { uiModal } from "@/components/ui/modal"
	import { uiButton } from "@/components/ui/buttons"
	import { uiOverlayLoad  } from '@/components/ui'

	export default {
		components: {
			uiModal,
			uiButton,
			uiOverlayLoad,
		},

		props: {
			/**
			 * Propriedade referente ao componente modal
			 */
			name: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Propriedade referente ao componente modal
			 */
			title: {
				type: String,
				required: false,
				default: ''
			},

			/**
			 * Propriedade referente ao componente modal
			 */
			icon: {
				type: String,
				required: false,
				default: ''
			},

			/**
			 * Define o load usado no component
			 * mostrado apenas na parte do conteúdo e não no menu lateral
			 */
			load: {
				type: Boolean,
				default: false,
				required: false
			},

			/**
			 * Define qual a etapa pré-selecionada
			 */
			default: {
				type: Number,
				default: 0,
				required: false
			}
		},

		data() {
			return {
				items: [],
				totalItems: 0,
				currentActive: 0,
				direction: null, //'next', 'prev'
			}
		},

		created() {
			// eslint-disable-next-line
			this.$on("is-valid", isValid => {
				if(this.currentActive === (this.totalItems - 1))
					this.submit()
				else
					this.nextItem()
			})
		},

		mounted() {
			/**
			 * Seleciona os filhos que são componentes especificamente com o nome de 'ui-step'
			 */
			this.$children[0].$children.forEach(item => {
				if (item.$options._componentTag === 'ui-step')
					this.items.push(item)
			})

			this.$nextTick()

			this.totalItems = this.items.length
		},

		methods: {
			select() {
				this.items.forEach(item => {
					item.isSelected = false
				})

				this.$nextTick()

				this.items[this.currentActive].isSelected = true
				this.items[this.currentActive].isValid = false
				this.items[this.currentActive].isChecked = false
			},

			previous() {
				this.items[this.currentActive].isChecked = false
				this.items[this.currentActive].isValid = false
				this.currentActive--
				this.$nextTick()
				this.select()
			},

			next() {
				this.items[this.currentActive].$emit('input')
			},

			nextItem() {
				this.items[this.currentActive].isChecked = true
				this.currentActive++
				this.$nextTick()
				this.select()
			},

			submit() {
				this.currentActive = 0
				this.$nextTick()
				this.select()
				this.$emit('submit')
				this.$children[0].close()
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>